import * as d3 from 'd3';
import {Arc, Pie, ScaleOrdinal, Selection} from 'd3';
import debounce from 'lodash.debounce';
import {Component} from 'lowkey-component';

import {ViewportObserver} from '@services/ViewportObserver';
import {WindowService} from '@services/WindowService';
import {colors} from '@services/utils';

export class ChartGender extends Component {
  _viewportObserver: ViewportObserver;
  target: SVGSVGElement | null = null;
  data: Object[] = [];
  isAnimated = false;
  isAnimation = false;
  window = WindowService.create();
  svg: Selection<any, any, any, any> | null = null;
  pie: Pie<any, any> | null = null;
  arc1: Arc<any, any> | null = null;
  arc2: Arc<any, any> | null = null;
  color: ScaleOrdinal<any, any> | null = null;
  width = 0;
  height = 0;

  constructor(element: HTMLDivElement) {
    super(element);
    this.resize = debounce(this.resize.bind(this), 500, {leading: true});

    this._viewportObserver = new ViewportObserver({margin: '-20%', ratio: 0.1});
  }

  didMount() {
    setTimeout(() => {
      const top = this.element.getBoundingClientRect().top + window.pageYOffset;
      const isOver = window.pageYOffset + window.innerHeight > top;
      if (isOver) {
        this.animate();
      } else {
        this._viewportObserver.onChange.connect((status) => {
          if (status === 'below') this.animate();
        });
      }
    }, 100); // msecまたないとwindow.pageYOffsetが0
    this._viewportObserver.observe(this.element);

    this.target = this.element.querySelector('svg') as SVGSVGElement;

    this.data = [
      {gender: 'female', data: 19},
      {gender: 'male', data: 81},
    ];
    this.svg = d3.select('#' + this.target.getAttribute('id'));
    this.pie = d3
      .pie()
      .sort(d3.descending)
      .value(function (d) {
        return d.data;
      });

    this.width = parseInt(this.svg.style('width'), 10);
    this.height = parseInt(this.svg.style('height'), 10);

    //--
    // this.arc = d3.arc().outerRadius(this.width / 2).innerRadius(100/2)
    // this.arc1 = d3.arc().outerRadius(this.width / 2).innerRadius(10)
    // this.arc2 = d3.arc().outerRadius(this.width / 2).innerRadius(10)
    this.arc1 = d3
      .arc()
      .outerRadius(this.width / 2 - 34)
      .innerRadius(50);
    this.arc2 = d3
      .arc()
      .outerRadius(this.width / 2)
      .innerRadius(50);

    this.color = d3.scaleOrdinal().range([colors.black, '#707070']);

    this.render();
    // this.resize()
    // this.window.onResize.connect(this.resize)
  }

  render() {
    this.svg?.selectAll('*').remove();

    const g = this.svg
      ?.selectAll('.arc')
      .data(this.pie(this.data))
      .enter()
      .append('g')
      .attr('class', 'arc')
      .attr('transform', `translate(${this.width / 2}, ${this.height / 2})`);

    g.append('path')
      // .attr('d', this.arc1)
      // .attr('d', (d) => {
      //   if (d.data.gender === 'male') {
      //     return this.arc1(d)
      //   } else {
      //     return this.arc2(d)
      //   }
      // })
      .attr('stroke', 'rgb(237, 224, 219)')
      .attr('stroke-width', 0)
      .style('fill', (d) => {
        return this.color(d.data.data);
      });

    g.append('text') //add a label to each slice
      .attr('transform', (d) => {
        //set the label's origin to the center of the arc
        // d.innerRadius = 0
        // d.outerRadius = this.width / 2
        if (d.data.gender == 'male') {
          return 'translate(' + this.arc1.centroid(d) + ')';
        } else {
          return 'translate(' + this.arc2.centroid(d) + ')';
        }
      })
      .attr('text-anchor', 'middle')
      .html((d) => {
        return d.data.data + '<tspan dx="5">%</tspan>';
      })
      // .attr('dx', (d) => {
      //   if (d.data.gender === 'male') {
      //     return -35;
      //   } else {
      //     return 0;
      //   }
      // })
      .attr('dy', (d) => {
        if (d.data.gender === 'male') {
          return 10;
        } else {
          return 13;
        }
      })
      .attr('opacity', 0);
  }

  resize() {
    this.width = parseInt(this.svg.style('width'), 10);
    this.height = parseInt(this.svg.style('height'), 10);
    console.log(this.width);

    this.arc1?.outerRadius(this.width / 2);
    this.arc2?.outerRadius(280);

    const g = this.svg
      .selectAll('.arc')
      .attr('transform', `translate(${this.width / 2}, ${this.height / 2})`);

    if (this.isAnimated) {
      g.selectAll('path').attr('d', this.arc1);
      // g.selectAll('path').attr('d', (d) => {
      //   if (d.data.gender === 'male') {
      //     return this.arc1(d)
      //   } else {
      //     return this.arc2(d)
      //   }
      // })
    }
  }

  animate() {
    if (this.isAnimation || this.isAnimated) {
      return;
    }

    this.isAnimation = true;
    const g = this.svg.selectAll('.arc');
    const length = this.data.length;
    let i = 0;

    g.selectAll('text')
      .transition()
      .ease(d3.easeCubicOut)
      .delay(1000)
      .duration(1000)
      .attr('opacity', 1);

    g.selectAll('path')
      .transition()
      .ease(d3.easeCubicOut)
      .delay(300)
      .duration(1500)
      .attrTween('d', (d) => {
        const interpolate = d3.interpolate(
          {startAngle: 0, endAngle: 0},
          {startAngle: d.startAngle, endAngle: d.endAngle},
        );
        return (t) => {
          if (d.data.gender === 'male') {
            return this.arc1(interpolate(t));
          } else {
            return this.arc2(interpolate(t));
          }
        };
      })
      .on('end', () => {
        i++;
        this.isAnimated = i === length; //最後の要素の時だけtrue
        this.isAnimation = !this.isAnimated;
      });
  }

  didUnmount() {
    this.window.onResize.disconnect(this.resize);
    this._viewportObserver.disconnect();
  }
}
